<div class="status-box">
  <img
    class="icon"
    src="{{ 'assets/images/dashboard/sandglass-blue.svg' | cheminAbsoluStatique }}"
    alt="{{ 'accessibilite.avis-icone' | translate }}"
    width="18"
    height="24"
  />
  <span id="{{ spanId }}" class="text" [innerHTML]="textContent"></span>
</div>
